module.exports = __webpack_public_path__ + "media/application/images/svgs/folder-minus-5d5c1fe5ad05dfc6c6fd990fe4facff1.svg";